import React from 'react'
import hang_on from '../assets/lottie/hang_on.json';
import Lottie, { useLottie } from 'lottie-react';


const AquaCodLoader = () => {
    const defaultOptions = {
        loop: true,
        autoplay: true,
        animationData: hang_on,
        rendererSettings: {
            preserveAspectRatio: "xMidYMid slice"
        }
    };
    const { View } = useLottie(defaultOptions);

    return (
        <div className='AquaCodLoaderFixed'>
           
                {View}
               
            <div className='codLoaderText'>
                <p>Hang in there!</p>
                <p>
                You will be automatically redirected to<br />
                order confirmation page in a few seconds.
                </p>
            </div>
        </div>
    )
}

export default AquaCodLoader
